<template>
<div id="contents">

  <div id="company" class="page_contents">

    <div id="company_contents">
      <div id="company_awards">
        <div class="page_header">
          <h1 class="page_header_title">
            <img src="../assets/img/company/title.png" width="300" alt="WORKS" />
            <span>会社について</span>
          </h1><!-- .top_sec_title -->
        </div><!-- .page_header -->

        <companyPageNav />

        <div id="company_awards_main">

          <ul id="award_nav">
            <li><a href="year2000" v-on:click.prevent="change2000" v-bind:class="{ 'active' : awards2000 }">2000年以降の受賞歴</a></li>
            <li><a href="year1999" v-on:click.prevent="change1999" v-bind:class="{ 'active' : awards1999 }">1999年までの受賞歴</a></li>
          </ul><!-- #award_nav -->

          <div id="award_list">

            <transition-group>
              <div v-for="award in award_list_add_date" :key="award.post_id" id="year2000" class="award_wrapper" v-show="awards2000">
                <div class="award_box">
                  <h3>{{ award.jp_year }}</h3>
                  <div>
                    <p>{{ award.content }}</p>
                  </div>
                </div><!-- #award_box -->
              </div><!-- #year2020 -->
            </transition-group>

            <transition-group>
              <div v-for="award in award_list_add_date" :key="award.post_id" id="year1999" class="award_wrapper" v-show="awards1999">
                <div class="award_box">
                  <h3>{{ award.jp_year }}</h3>
                  <div>
                    <p>{{ award.content }}</p>
                  </div>
                </div><!-- #award_box -->
              </div><!-- #year1999 -->
            </transition-group>

          </div><!-- #award_list -->

        </div><!-- #company_awrads_main -->

      </div><!-- #company_awrads -->
    </div><!-- #company_contents -->
  </div><!-- #company -->



</div><!-- #contents -->
</template>

<script>
import companyPageNav from './shared/companyPageNav.vue'
export default {
  name: 'awards_index',
  data() {
    return {
      api_url: this.$parent.api_base_url+'/api/award/index.php',
      award_2000_list: null,
      award_1999_list: null,
      error: null,
      awards2000: true,
      awards1999: false
    }
  },
  components: {
    companyPageNav
  },
  computed: {
    award_list_add_date: function () {
      var award_list = []
      this.awards2000 ? award_list = this.award_2000_list : award_list = this.award_1999_list ;
      if(award_list){
        return award_list.filter(function (award) {
          var year = award.date
          if (year > 2018) {
            return year-2018 == 1 ? award.jp_year = year+"（平成31・令和1）" : award.jp_year = year+"（令和"+(year-2018)+"）";
          } else if (year > 1988) {
            return year-1988 == 1 ? award.jp_year = year+"（昭和64・平成1）" : award.jp_year = year+"（平成"+(year-1988)+"）";
          } else if (year > 1925) {
            return award.jp_year = year+"（昭和"+(year-1925)+"）";
          }
        })
      }
    }
  },
  methods: {
    fetch_award_list(){
      this.$axios
        .get(this.api_url)
        .then(response => {
          this.award_2000_list = response.data.award_2000_item
          this.award_1999_list = response.data.award_1999_item
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.$emit('page_fade'))
    },
    change2000(e){
      this.awards2000 = true
      this.awards1999 = false
    },
    change1999(){
      this.awards2000 = false
      this.awards1999 = true
    }
  },
  mounted () {
    this.fetch_award_list()
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/awards_index.vue